export enum TokenTypeEnum {
  ACCESS = "ACCESS",
  REFRESH = "REFRESH",
  INVITATION = "INVITATION",
  PASSWORD_RESET = "PASSWORD_RESET",
  API_KEY = "API_KEY",
}
